import { render, staticRenderFns } from "./search-nodata.vue?vue&type=template&id=1091abf0&"
import script from "./search-nodata.vue?vue&type=script&lang=js&"
export * from "./search-nodata.vue?vue&type=script&lang=js&"
import style0 from "./search-nodata.vue?vue&type=style&index=0&id=1091abf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports